<template>
  <DashboardLayout>
    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <!-- Dynamic Parent -->
      <router-link v-if="fromNotifications"
        :to="{ name: 'ViewPendingNotifications', query: { entityType: route.query.entityType, statusInd: route.query.statusInd } }"
        class="mb-0 main-identifier fw-semibold text-decoration-none">
        Notifications
      </router-link>

      <router-link v-else :to="{ name: 'ViewMemo', params: { id: id } }"
        class="mb-0 main-identifier fw-semibold text-decoration-none">
        Memo
      </router-link>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Initiate Appraisal</p>
    </div>

    <div class="d-flex justify-content-center mb-5">

      <div class="form-outer">
        <form @submit.prevent="step === totalSteps ? handleSubmit() : handleNext()">
          <div class="crud-form position-relative">

            <div class="form-inner mb-2">
              <div class="form-header d-flex justify-content-between align-items-center">
                <!-- <h1 class="mb-0">Initiate Appraisal (Step {{ step }} of {{ totalSteps }})</h1> -->
                <h1 class="mb-0">Initiate Appraisal</h1>
              </div>

              <div class="header-box d-flex justify-content-between align-items-center mb-3">
                <div class="progress-bar" :style="{
                  '--progress-width': progressWidth,
                  '--step-count': totalSteps
                }">
                  <!-- Row 1: Step Icons -->
                  <div class="step-icon" v-for="(s, i) in totalSteps" :key="'icon-' + i">
                    <div :class="['step', { active: step === i + 1, completed: step > i + 1 }]">
                      {{ step > i + 1 ? '✓' : i + 1 }}
                    </div>
                  </div>

                  <!-- Row 2: Progress Line -->
                  <div class="progress-line" :style="{ '--progress-width': progressWidth }" />

                  <!-- Row 3: Step Labels -->
                  <div class="step-label text-wrap" v-for="(s, i) in steps" :key="'label-' + i"
                    :class="{ active: step === i + 1 }">
                    {{ s.label }}
                  </div>
                </div>
              </div>

              <div v-if="hasAssociatedPaymentVoucher" class="marquee-wrapper">
                <div class="marquee-content">
                  <p>
                    <span class="material-symbols-outlined">
                      asterisk
                    </span> This memo has an associated Payment Voucher
                  </p>
                  <p>
                    <span class="material-symbols-outlined">
                      asterisk
                    </span>This memo has an associated Payment Voucher
                  </p>
                  <p>
                    <span class="material-symbols-outlined">
                      asterisk
                    </span>This memo has an associated Payment Voucher
                  </p>
                </div>
              </div>

              <div v-if="step === 1">

                <div class="form-body">
                  <!-- <h2 class="field-head">A. General Information</h2> -->
                  <div class="row mb-3">
                    <!-- <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">Sector</label></div>
                      <div class="col-md-9 input-right">
                        <select class="form-select" v-model="sector" required disabled>
                          <option value="" disabled>- Select Sector -</option>
                          <option v-for="sector in sectors" :key="sector.id" :value="sector.id">{{ sector.code }} ({{
                            sector.name }})</option>
                        </select>
                      </div>
                    </div> -->

                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">Originating MDA</label>
                      </div>
                      <div class="col-md-9 input-right">
                        <select class="form-select" v-model="mda" required disabled>
                          <option value="" disabled>- Select MDA -</option>
                          <option v-for="mda in mdas" :key="mda.id" :value="mda.id">{{ mda.name }}</option>
                        </select>
                        <input type="hidden" v-model="form.mdaName">
                      </div>
                      <!-- <div v-if="mdaFieldEditable" class="col-md-9 input-right d-flex align-items-center gap-2">
                        <select class="form-select editable" v-model="mda" @change="onMdaChange" required>
                          <option value="" disabled>- Select MDA -</option>
                          <option v-for="mda in mdas" :key="mda.id" :value="mda.id">{{ mda.name }}</option>
                        </select>
                        <span class="material-symbols-outlined edit-icon-filled" title="Edit Originating MDA"
                          @click="toggleEditField('mda')">
                          edit
                        </span>
                        <input type="hidden" v-model="form.mdaName">
                      </div>

                      <div v-else class="col-md-9 input-right d-flex align-items-center gap-2">
                        <input id="OriginatingMda" type="text" class="form-control form-view-only-input"
                          v-model="form.mdaName" placeholder="" readonly disabled />
                        <span class="material-symbols-outlined edit-icon" title="Edit Originating MDA"
                          @click="toggleEditField('mda')">
                          edit
                        </span>
                        <input type="hidden" v-model="form.mdaName">
                      </div> -->
                    </div>

                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">Approval Authority</label></div>
                      <div class="col-md-9 input-right">
                        <select class="form-select" v-model="form.approval_authority" @change="syncApprovalAuthority"
                          required>
                          <option value="" selected>- Select Approving Authority -</option>
                          <option v-for="app in approval_authorities" :key="app.id" :value="app.id">
                            {{ app.description }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">Budget Year</label></div>
                      <div class="col-md-9 input-right">
                        <select class="form-select" v-model="form.year" required>
                          <option value="" disabled>Select Year</option>
                          <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">Quarter</label></div>
                      <div class="form-row-input d-flex align-items-center gap-2">
                        <select class="form-select" v-model="form.quarter" required>
                          <option value="" disabled>- Select Quarter -</option>
                          <option v-for="q in quarters" :key="q" :value="q">Q{{ q }}</option>
                        </select>
                        <span v-if="form.quarter" @click="viewApprovalAuthorityInfoModal"
                          class="material-symbols-outlined" title="Click to view Approval Authority Information">
                          info
                        </span>
                      </div>
                    </div>

                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">Nature of Expenditure</label></div>
                      <div class="col-md-9 input-right">
                        <select class="form-select" v-model="form.nature_expenditure" @change="clearEcoOptions"
                          required>
                          <option value="" disabled>- Select Economic Code Type -</option>
                          <option value="3">Capital</option>
                          <option value="2">Recurrent</option>
                          <option value="4">Hybrid</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">Amount Approved</label>
                      </div>
                      <div class="col-md-9 input-right">
                        <input id="amountApproved" type="text" class="form-control"
                          :value="formatCurrency(form.amount_approved)" inputmode="numeric" pattern="[0-9,]*"
                          @keypress="onlyDigitsAndComma" @input="onAmountApprovedInput" placeholder="" required
                          disabled />
                      </div>
                      <!-- <div v-if="amountApprovedFieldEditable"
                        class="col-md-9 input-right d-flex align-items-center gap-2">
                        <input id="amountApproved" type="text" class="form-control editable"
                          :value="formatCurrency(form.amount_approved || 0)" inputmode="numeric" pattern="[0-9,]*"
                          @keypress="onlyDigitsAndComma" @input="onAmountApprovedInput" placeholder="0.00" required />
                        <span class="material-symbols-outlined edit-icon-filled" title="Edit Amount Approved"
                          @click="toggleEditField('amountApproved')">
                          edit
                        </span>
                      </div>

                      <div v-else class="col-md-9 input-right d-flex align-items-center gap-2">
                        <input id="amountApproved" type="text" class="form-control"
                          :value="formatCurrency(form.amount_approved || 0)" inputmode="numeric" pattern="[0-9,]*"
                          @keypress="onlyDigitsAndComma" @input="onAmountApprovedInput" placeholder="0.00" required
                          disabled />
                        <span class="material-symbols-outlined edit-icon" title="Edit Amount Approved"
                          @click="toggleEditField('amountApproved')">
                          edit
                        </span>
                      </div> -->
                    </div>

                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                          class="form-label">Purpose of Request</label></div>
                      <div class="col-md-9 input-right">
                        <div class="col-md-12 input-right">
                          <textarea class="form-control" id="description" v-model="form.purpose_request" placeholder=""
                            rows="3" maxlength="200" required></textarea>
                          <small class="form-text text-muted char-counter"
                            :title="`${remainingChars(form.purpose_request)} characters remaining`">
                            {{ (form.purpose_request || '').length }}/200 characters
                          </small>
                        </div>
                      </div>
                    </div>

                    <input type="hidden" v-model="memoFileNumber">
                  </div>
                </div>
              </div>

              <div v-if="step === 2">
                <!-- <h2 class="field-head">B. Budget</h2> -->

                <div class="row mb-3 budget-item-wrapper step-2 justify-content-center">
                  <div class="row content-wrapper section-border h-100 w-100">
                    <div class="col d-flex">
                      <div class="d-flex flex-column justify-content-center h-100 w-100">
                        <label class="form-label fw-bold fixed-label">Organizational Code</label>
                        <input type="text" class="form-control view-only-input text-center" v-model="form.orgCode"
                          readonly>
                      </div>
                    </div>
                    <div class="col d-flex">
                      <div class="d-flex flex-column justify-content-center h-100 w-100">
                        <label class="form-label fw-bold fixed-label">Approved Budget Amount</label>
                        <input type="hidden" v-model="form.app_budget_line" />
                        <!-- display the formatted string -->
                        <input type="text" class="form-control view-only-input text-center"
                          :value="formatCurrency(form.app_budget_line || 0).toLocaleString()" readonly />
                      </div>
                    </div>
                    <div class="col d-flex">
                      <div class="d-flex flex-column justify-content-center h-100 w-100">
                        <label class="form-label fw-bold fixed-label">Approved Released To Date</label>
                        <input type="text" class="form-control view-only-input text-center"
                          :value="formatCurrency(form.app_released_line || 0).toLocaleString()" readonly>
                      </div>
                    </div>
                    <div class="col d-flex">
                      <div class="d-flex flex-column justify-content-center h-100 w-100">
                        <label class="form-label fw-bold fixed-label">Balance</label>
                        <input type="hidden" v-model="form.balance_line" />
                        <!-- display the formatted string -->
                        <input type="text" class="form-control view-only-input text-center"
                          :value="formatCurrency(form.balance_line || 0).toLocaleString()" readonly />
                      </div>
                    </div>
                    <div class="col d-flex no-border">
                      <div class="d-flex flex-column justify-content-center h-100 w-100">
                        <label class="form-label fw-bold fixed-label ">Performance</label>
                        <input type="text" class="form-control view-only-input text-center"
                          :value="Number(form.performance_line || 0).toFixed(2) + '%'" readonly>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="table-responsive mt-4">
                  <table class="table table-bordered text-center align-middle">
                    <thead class="table-light">
                      <tr>
                        <th>Eco Code</th>
                        <th>Title</th>
                        <th>Approved Budget {{ form.budget_year_line }}</th>
                        <th>Approval Release To Date</th>
                        <th>Balance</th>
                        <!-- <th>Performance (%)</th> -->
                        <th>Amount Required (₦)</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in economicItems" :key="index"
                        :class="index % 2 === 0 ? 'row-even' : 'row-odd'">
                        <td>
                          {{ item.ecoCode }}
                        </td>
                        <td>
                          {{ item.title }}
                        </td>
                        <td>
                          {{ formatCurrency(item.approvedBudget || 0).toLocaleString() }}
                        </td>
                        <td>
                          {{ formatCurrency(item.releasedToDate || 0).toLocaleString() }}
                        </td>
                        <td>
                          {{ formatCurrency(item.balance || 0).toLocaleString() }}
                        </td>
                        <!-- <td>
                                        {{ item.performance }}%
                                      </td> -->
                        <td>
                          <input type="text" class="form-control text-center"
                            :value="formatCurrency(item.amountRequired)" inputmode="numeric" pattern="[0-9,]*"
                            @keypress="onlyDigitsAndComma" @input="e => onItemAmountInput(e, item)" placeholder="0"
                            :title="`Memo Amount Required is ${formatCurrency(form.amount_approved)}`" required />
                        </td>

                        <!-- <td>
                                        <input
                                          type="number"
                                          min="0"
                                          class="form-control form-control-sm"
                                          v-model.number="item.amountRequired"
                                          @input="validateBudgetStep"
                                        />
                                        {{ item.amountRequired }}
                                      </td> -->
                        <td>
                          <button type="button" class="btn btn-outline-danger btn-sm" @click="removeItem(index)">
                            <span class="iconify" data-icon="mdi:trash-can-outline"></span>
                          </button>
                          <input type="hidden" v-model="item.mdaLineItemBudgetId" />
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div class="mt-3">
                    <h5 class="mb-2" style="font-size: 16px;">Select Economic Line Item to Add:</h5>

                    <div class="d-flex justify-content-center">
                      <div class="d-flex align-items-end gap-2 flex-wrap">
                        <!-- Search Input with Label -->
                        <div class="d-flex flex-column" style="max-width: 160px;">
                          <label class="form-label mb-1 text-muted" style="font-size: 13px;">Filter Options</label>
                          <input type="text" v-model="searchTerm" placeholder="Search title/code"
                            class="form-control form-control-sm" />
                        </div>

                        <!-- Select Dropdown with Label -->
                        <div class="d-flex flex-column" style="max-width: 220px;">
                          <label class="form-label mb-1 text-muted" style="font-size: 13px;">Choose Line Item</label>
                          <select class="form-select form-select-sm" v-model="newEcoId" @change="onSelectEco">
                            <option value="" disabled>-- pick code --</option>
                            <option v-for="opt in filteredEcoOptions" :key="opt.id" :value="opt.id">
                              {{ opt.ecoCode }} — {{ opt.title }}
                            </option>
                          </select>
                        </div>

                        <!-- Add Button -->
                        <div class="d-flex flex-column">
                          <label class="invisible mb-1">Add</label>
                          <button type="button" class="btn btn-outline-primary btn-sm" :disabled="!newEcoId"
                            @click="addSelectedEco">
                            <span class="iconify" data-icon="mdi:plus"></span>
                            Add Item
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="mt-3 text-end">
                                  <button type="button" class="btn btn-outline-primary btn-sm" @click="addEconomicItem">
                                    <span class="iconify" data-icon="mdi:plus"></span> Add More
                                  </button>
                                </div> -->
                </div>
              </div>

              <div v-if="step === 3">
                <!--                <h2 class="field-head">C. Evaluation Of Expenditure Approval Limits</h2> -->

                <div class="row mb-3 align-items-center justify-content-center">
                  <div class="row form-group position-relative floating-label-group">
                    <div class="col-md-1 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label fw-bold">Year:</label></div>
                    <div class="col-md-1 input-right">
                      <input type="text" class="form-control view-only-input" v-model="form.year" placeholder=""
                        readonly>
                    </div>

                    <div class="col-md-1 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label fw-bold">Date:</label></div>
                    <div class="col-md-2 input-right">
                      <input type="text" class="form-control view-only-input" :value="formatInitDate(form.exp_date)"
                        placeholder="" readonly>
                    </div>

                    <div class="col-md-2 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label fw-bold">Approval Authority:</label></div>
                    <div class="col-md-3 input-right">
                      <input type="text" class="form-control view-only-input app-auth-tooltip-wrapper"
                        v-model="form.exp_app_auth" placeholder="" readonly>
                      <span class="app-auth-tooltip-text">
                        This is the authority responsible for approving expenditure requests.
                      </span>
                    </div>

                    <div class="col-md-1 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label fw-bold">Quarter:</label></div>
                    <div class="col-md-1 input-right">
                      <input type="text" class="form-control view-only-input" v-model="form.exp_quarter" placeholder=""
                        readonly>
                    </div>
                  </div>

                  <div class="row g-4 m-0 mb-5 budget-item-wrapper justify-content-center step-3 align-items-stretch">
                    <!-- Left side-->
                    <div class="col-md-6">
                      <div class="col content-wrapper section-border h-100 w-100">
                        <div class="content d-flex">
                          <label for="year" class="form-label fw-bold fixed-label">Quarterly Authorized Amount</label>
                          <input type="hidden" v-model="form.exp_auth_amount">
                          <input type="text" class="form-control view-only-input text-end"
                            :value="form.approval_authority_unlimited ? 'Unlimited' : (formatCurrency(form.exp_auth_amount || 0).toLocaleString())"
                            placeholder="" readonly>
                        </div>

                        <div class="content d-flex">
                          <label for="year" class="form-label fw-bold fixed-label">Approved Recurrent Amount</label>
                          <input type="hidden" v-model="form.exp_rec_amount">
                          <input type="text" class="form-control view-only-input text-end"
                            :value="formatCurrency(form.exp_rec_amount || 0).toLocaleString()" placeholder=""
                            readonly>
                        </div>

                        <div class="content d-flex">
                          <label for="year" class="form-label fw-bold fixed-label">Approved Capital Amount</label>
                          <input type="hidden" v-model="form.exp_cap_amount">
                          <input type="text" class="form-control view-only-input text-end"
                            :value="formatCurrency(form.exp_cap_amount || 0).toLocaleString()" placeholder=""
                            readonly>
                        </div>

                        <div class="content d-flex">
                          <label for="year" class="form-label fw-bold fixed-label">Approval Balance</label>
                          <input type="hidden" v-model="form.exp_app_balance">
                          <input type="text" class="form-control view-only-input text-end"
                            :value="formatCurrency(form.approval_authority_unlimited ? totalApprovedInQtr : (form.exp_app_balance || 0)).toLocaleString()"
                            placeholder="" readonly>
                        </div>
                      </div>
                    </div>

                    <!-- Right side-->
                    <div class="col-md-6">
                      <div class="col content-wrapper section-border h-100 w-100">
                        <div class="content d-flex">
                          <label for="year" class="form-label fw-bold fixed-label">Quarterly Authorization Limit
                            Number</label>
                          <input type="text" class="form-control view-only-input text-end"
                            :value="form.approval_authority_unlimited ? 'Unlimited' : form.exp_app_quarter"
                            placeholder="" readonly>
                        </div>

                        <div class="content d-flex">
                          <label for="year" class="form-label fw-bold fixed-label">Number Already Approved In
                            Quarter</label>
                          <input type="text" class="form-control view-only-input text-end"
                            v-model="form.exp_limit_number" placeholder="" readonly>
                        </div>

                        <div class="content d-flex">
                          <label for="year" class="form-label fw-bold fixed-label">Quarterly Authorized Limit
                            Balance</label>
                          <input type="text" class="form-control view-only-input text-end"
                            :value="form.approval_authority_unlimited ? 'Unlimited' : form.exp_limit_balance"
                            placeholder="" readonly>
                        </div>

                      </div>
                    </div>
                  </div>

                  <div
                    class="col-md-11 row form-group position-relative floating-label-group content-wrapper section-border">
                    <div class="col-md-1 label-left d-flex justify-content-end align-items-center">
                      <label for="remark" class="form-label">Remark</label>
                    </div>
                    <div class="col-md-11 input-right">
                      <div class="col-md-12 input-right">
                        <textarea class="form-control" id="description" v-model="form.exp_remark" placeholder=""
                          rows="3" maxlength="200" required></textarea>
                        <small class="form-text text-muted char-counter"
                          :title="`${remainingChars(form.exp_remark)} characters remaining`">
                          {{ (form.exp_remark || '').length }}/200 characters
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div v-if="step === 4">
                              <h2 class="field-head">D. Recommendation</h2>

                              <div class="row mb-3">

                                  <div class="col-md-12 row form-group position-relative floating-label-group">
                                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year" class="form-label">Approval Balance</label></div>
                                    <div class="col-md-9 input-right">
                                      <input type="number" class="form-control" v-model="name" placeholder="" required>
                                    </div>
                                  </div>

                                  <div class="col-md-12 row form-group position-relative floating-label-group">
                                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year" class="form-label">Sectoral Head Remark</label></div>
                                    <div class="col-md-9 input-right">
                                      <div class="col-md-12 input-right">
                                          <textarea
                                          class="form-control"
                                          id="description"
                                          v-model="description"
                                          placeholder=""
                                          rows="3"
                                          required
                                          ></textarea>
                                        </div>
                                    </div>
                                  </div>

                                  <div class="col-md-12 row form-group position-relative floating-label-group">
                                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year" class="form-label">Director Of Budget Remark</label></div>
                                    <div class="col-md-9 input-right">
                                      <div class="col-md-12 input-right">
                                          <textarea
                                          class="form-control"
                                          id="description"
                                          v-model="description"
                                          placeholder=""
                                          rows="3"
                                          required
                                          ></textarea>
                                        </div>
                                    </div>
                                  </div>

                                  <div class="col-md-12 row form-group position-relative floating-label-group">
                                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year" class="form-label">Permanent Secretary Remark</label></div>
                                    <div class="col-md-9 input-right">
                                      <div class="col-md-12 input-right">
                                          <textarea
                                          class="form-control"
                                          id="description"
                                          v-model="description"
                                          placeholder=""
                                          rows="3"
                                          required
                                          ></textarea>
                                        </div>
                                    </div>
                                  </div>

                                  <div class="col-md-12 row form-group position-relative floating-label-group">
                                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year" class="form-label">Commissioner Remark</label></div>
                                    <div class="col-md-9 input-right">
                                      <div class="col-md-12 input-right">
                                          <textarea
                                          class="form-control"
                                          id="description"
                                          v-model="description"
                                          placeholder=""
                                          rows="3"
                                          required
                                          ></textarea>
                                        </div>
                                    </div>
                                  </div>
                              </div>
                            </div> -->

              <div class="mt-4">
                <div v-if="step === 1" class="d-flex justify-content-end">
                  <button type="button" class="btn btn-primary next-btn d-inline-flex align-items-center"
                    @click="handleNext" :disabled="loading" :aria-label="loading ? 'Loading…' : 'Next step'"
                    aria-live="polite">
                    <!-- Spinner appears only when loading = true -->
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                      aria-hidden="true"></span>

                    <!-- Button text -->
                    <span class="me-2">{{ loading ? 'Loading...' : 'Next' }}</span>

                    <!-- Iconify arrow icon -->
                    <span class="iconify" data-icon="formkit:arrowright" style="font-size: 1.2em;"></span>
                  </button>
                </div>

                <div v-else-if="step < totalSteps" class="d-flex justify-content-between">
                  <button type="button" class="btn btn-secondary back-btn" @click="handleBack">
                    <span class="iconify" data-icon="formkit:arrowleft" style="font-size: 1.2em;"></span>
                    Previous
                  </button>

                  <button type="button" class="btn btn-primary next-btn d-inline-flex align-items-center"
                    @click="handleNext" :disabled="loading" :aria-label="loading ? 'Loading…' : 'Next step'"
                    aria-live="polite">
                    <!-- Spinner appears only when loading = true -->
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                      aria-hidden="true"></span>

                    <!-- Button text -->
                    <span class="me-2">{{ loading ? 'Loading...' : 'Next' }}</span>

                    <!-- Iconify arrow icon -->
                    <span class="iconify" data-icon="formkit:arrowright" style="font-size: 1.2em;"></span>
                  </button>
                  <!-- <button type="button" class="btn btn-outline-primary next-btn" @click="handleNext">
                                  <span>Next</span>
                                  <span class="iconify" data-icon="formkit:arrowright" style="font-size: 1.2em;"></span>
                                </button> -->
                </div>



                <div v-else-if="step === totalSteps" class="d-flex justify-content-center gap-3">
                  <button type="button" class="btn btn-secondary back-btn" @click="handleBack">
                    <span class="iconify" data-icon="formkit:arrowleft" style="font-size: 1.2em;"></span>
                    Previous
                  </button>

                  <button type="submit" class="btn btn-primary submit-btn" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                      aria-hidden="true"></span>
                    {{ (loading ? 'Submitting...' : 'Submit') }}
                  </button>

                </div>
              </div>

            </div>

          </div>
        </form>
      </div>
    </div>

    <div v-if="showApprovalAuthorityInfoModal" class="app-auth-info-overlay" @click="closeApprovalAuthorityInfoModal">
      <div class="app-auth-info-modal" @click.stop>
        <div class="app-auth-info-header">
          <h5 class="mb-0">Approval Authority Details</h5>
          <button type="button" class="btn-close" aria-label="Close" @click="closeApprovalAuthorityInfoModal"></button>
        </div>

        <div class="app-auth-info-body">
          <div v-if="loadingApprovalAuthorityInfo" class="info-grid mb-3">
            <div class="info-item" v-for="n in 5" :key="n">
              <small>&nbsp;</small>
              <p class="mb-0 app-auth-skeleton-bar"></p>
            </div>
          </div>

          <p v-else-if="approvalAuthorityInfoError" class="text-danger mb-0">{{ approvalAuthorityInfoError }}</p>

          <div v-else>
            <div class="info-grid mb-3">
              <div class="info-item">
                <small>Approval Authority Name</small>
                <p class="mb-0">{{ approvalAuthorityInfo?.name || 'N/A' }}</p>
              </div>
              <div class="info-item">
                <small>Approval Limit Per Quarter</small>
                <p class="mb-0">{{ formatNumber(approvalAuthorityInfo?.limitPerQtr) || 'N/A' }}</p>
              </div>
              <div class="info-item">
                <small>Approval Amount Per Quarter</small>
                <p class="mb-0">{{ formatCurrency(approvalAuthorityInfo?.approvalAmtPerQtr) || 'N/A' }}</p>
              </div>
              <div class="info-item">
                <small>Max Approval Amount Per Quarter</small>
                <p class="mb-0">{{ formatCurrency(approvalAuthorityInfo?.maxAmtPerQtr) || 'N/A' }}</p>
              </div>
              <div class="info-item">
                <small>Approved Capex Percentage</small>
                <p class="mb-0">{{ formatPercent(approvalAuthorityInfo?.carpexPercentage) || 'N/A' }}</p>
              </div>
              <div class="info-item">
                <small>Approved Recurrent Percentage</small>
                <p class="mb-0">{{ formatPercent(approvalAuthorityInfo?.recurrentPercentage) || 'N/A' }}</p>
              </div>
            </div>
          </div>

          <div>
            <small>Appraisal Log</small>
            <div class="table-responsive mt-2">
              <table class="table table-bordered">
                <thead class="table-light">
                  <tr>
                    <th></th>
                    <th>Originating MDA</th>
                    <th class="text-end">Amount Approved</th>
                    <th class="text-end">Balance</th>
                    <th>Appraisal Initiation Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(appraisal_log, index) in paginatedItems" :key="appraisal_log.id"
                    :class="index % 2 === 0 ? 'row-even' : 'row-odd'">
                    <td data-label="S/N" class="serial-no text-center">
                      {{ (currentPage - 1) * pageLength + index + 1 }}
                    </td>
                    <td data-label="Originating MDA" class="primary-col">
                      <router-link
                        :to="{ name: 'ViewAppraisal', params: { id: appraisal_log.id }, query: { mdaid: appraisal_log.mdaId, year: appraisal_log.year } }"
                        class="view-link text-decoration-underline" @mouseenter="showTooltip($event, appraisal_log)"
                        @mouseleave="hideTooltip">
                        {{ appraisal_log.originatingMda }}
                      </router-link>
                    </td>
                    <td data-label="Amount Approved" class="secondary-col amount">
                      {{ formatCurrency(appraisal_log.amountApproved || 0).toLocaleString() }}
                    </td>
                    <td data-label="Balance" class="secondary-col amount">
                      {{ formatCurrency(appraisal_log.balance || 0).toLocaleString() }}
                    </td>
                    <td data-label="Appraisal Initiation Date" class="secondary-col appraisal-date">
                      {{ formatInitDate(appraisal_log.appraisalInitiatedDate) }}
                    </td>
                  </tr>
                  <tr v-if="paginatedItems.length === 0">
                    <td colspan="5" class="text-center">
                      No appraisal log available for this approval authority.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Tooltip -->
              <div v-if="tooltipVisible && hoveredItem" class="custom-tooltip" :style="{
                top: tooltipY + 'px',
                left: tooltipX + 'px'
              }">
                <div v-if="isLoadingDetails">
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Loading details...
                </div>
                <div v-else>
                  <p><strong>Details</strong></p>
                  <!-- APPRAISAL -->
                  <div>
                    <p><strong>MDA: </strong>{{ hoveredItem.originatingMda || hoveredItem.mda || 'N/A' }}</p>
                    <!-- <p><strong>Approval Authority: </strong>{{ hoveredItem.approvalAuthority || hoveredItem.approvalAuthorityName || 'N/A' }}</p> -->
                    <p><strong>Nature of Expenditure: </strong>{{ hoveredItem.natureOfExpenditure || 'N/A' }}</p>
                    <p><strong>Purpose of Request: </strong>{{ hoveredItem.purposeOfRequest || 'N/A' }}</p>
                    <!-- <p><strong>Amount Approved: </strong>{{ formatCurrency(hoveredItem.amountApproved || hoveredItem.amount || 0) }}</p> -->
                    <p><strong>Org Code: </strong>{{ hoveredItem.orgCode || 'N/A' }}</p>
                    <!-- <p><strong>Balance:</strong> {{ formatCurrency(hoveredItem.balance || 0) }}</p>
                    <p><strong>Performance:</strong> {{ Number(hoveredItem.performance).toFixed(1) }}%</p>
                    <p><strong>Budget Year:</strong> {{ hoveredItem.budgetYear }}</p>
                    <p><strong>Quarter:</strong> {{ hoveredItem.quarter }}</p>
                    <p><strong>Approved Budget Amount:</strong> {{ formatCurrency(hoveredItem.approvedBudgetAmount || 0) }}</p>
                    <p><strong>Amount Released To Date:</strong> {{ formatCurrency(hoveredItem.amtReleasedToDate || 0) }}</p>
                    <p><strong>Approval Balance:</strong> {{ formatCurrency(hoveredItem.approvalBalance || 0) }}</p> -->
                  </div>
                </div>
              </div>

            <!-- Pagination Summary and Actions -->
              <div class="pagination-info">
                <small>
                  Showing {{ (currentPage - 1) * pageLength + 1 }} to
                  {{ Math.min(currentPage * pageLength, totalElements) }} of
                  {{ totalElements }} entries
                </small>

                <!-- Pagination Controls -->
                <nav class="pagination-nav">
                  <ul class="pagination pagination-sm mb-0" :class="{ 'pe-none opacity-50': loading }">
                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                      <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">Previous</a>
                    </li>
                    <li v-for="page in displayedPages" :key="page" class="page-item"
                      :class="{ active: currentPage === page }">
                      <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                    </li>
                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                      <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">Next</a>
                    </li>
                  </ul>
                </nav>
              </div>

          </div>
        </div>
      </div>
    </div>

  </DashboardLayout>
</template>

<script setup>
import { ref, reactive, onMounted, computed, watch } from 'vue'
import axios from 'axios'
import DashboardLayout from '../layout/DashboardLayout.vue'
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import { useRoute } from 'vue-router';
import { useUserStore } from '@/stores/user'

const userStore = useUserStore()
const userId = ref('')

// const router = useRouter();

const approval_authorities = ref([])
const memo_details = ref([])
const mda_details = ref([])
const subsector_details = ref([])
// const sector_details = ref([])

const appraisal_log = ref([])
const mdas = ref([])

// const sectors = ref([])

const sector = ref('')
const mda = ref('')
const route = useRoute()
const memo_id = route.params.id

const root_api_url = process.env.VUE_APP_API_ROOT_URL
const totalSteps = 3
const step = ref(1)
const loading = ref(false)
// const isEditable = ref(true)
// const isEdited = ref(false)
// const isPendingApproval = ref(false)

const memoFileNumber = ref('')
// const occupier_details = ref(null)

const showApprovalAuthorityInfoModal = ref(false);
const loadingApprovalAuthorityInfo = ref(false);
const isLoadingDetails = ref(false)
const approvalAuthorityInfoError = ref('');
const approvalAuthorityInfo = ref(null);
const hoveredItem = ref(null)
const tooltipVisible = ref(false)
const tooltipX = ref(0)
const tooltipY = ref(0)
const pageLength = ref(10)
const currentPage = ref(1)

const filters = ref({
  date: '',
})
const errorMessage = ref('')
const tableNotice = ref('')

// Progress bar and step
const steps = [
  { label: 'General Information' },
  { label: 'Budget' },
  { label: 'Evaluation Of Expenditure Approval Limits' }
]

// const progressWidth = computed(() => {
//   const stepPercentage = {
//     1: '33.33%',
//     2: '66.66%',
//     3: '100%',
//   };
//   return stepPercentage[step.value] || '0%';
// });

const progressWidth = computed(() => {
  const total = steps.length;
  const percentPerStep = 100 / total; // each step adds this much
  return (step.value * percentPerStep) + '%';
});

// Reactive form data
const form = reactive({
  mda: '',
  mdaName: '',
  organizationCode: '',
  economicLineItemId: '',
  year: '',
  orgCode: '',
  app_budget_line: '',
  app_released_line: '',
  balance_line: '',
  performance_line: '',
  budget_year_line: '',
  nature_expenditure: '',
  approval_authority: '',
  approval_authority_id: '',
  approval_authority_name: '',
  approval_authority_unlimited: false,
  amount_approved: '',
  purpose_request: '',
  exp_quarter: '',
  exp_date: '',
  exp_limit_number: '',
  exp_app_quarter: '',
  exp_limit_balance: '',
  exp_auth_amount: '',
  exp_cap_amount: '',
  exp_rec_amount: '',
  exp_app_balance: '',
  exp_remark: '',
  mdaLineItemBudgetId: '',
  exp_app_auth: '',
  quarter: '',
  groupTypeId: '',
  pvMemoId: '',
  payVoucherId: '',
})

// const appraisal = reactive({
//   oldMdaId: '',
//   oldAmountApproved: '',
// })

const hasValue = (value) => {
  return value !== null && value !== undefined && String(value).trim() !== ''
}

const hasAssociatedPaymentVoucher = computed(() => hasValue(form.pvMemoId) || hasValue(form.payVoucherId))

const initialForm = JSON.parse(JSON.stringify(form));

function resetAll() {
  // back to step 1mdaLineItemBudgetId
  step.value = 1;

  // clear selects
  sector.value = '';
  mda.value = '';
  mdas.value = [];
  approval_authorities.value = [];
  memo_details.value = [];
  mda_details.value = [];
  subsector_details.value = [];

  // restore form fields
  Object.assign(form, JSON.parse(JSON.stringify(initialForm)));

  // clear dynamic lists & controls
  economicItems.value = [];
  newEcoId.value = '';
  searchTerm.value = '';
}

const currentYear = new Date().getFullYear();
const years = ref(Array.from({ length: currentYear - 2023 + 1 }, (_, i) => currentYear - i));
const quarters = computed(() => {
  const currentMonth = (new Date().getMonth() + 1);
  if ((currentMonth >= 1 && currentMonth <= 3) && form.year == currentYear) {
    return [1]; // Q1
  } else if ((currentMonth >= 4 && currentMonth <= 6) && form.year == currentYear) {
    return [1, 2]; // Q2
  } else if ((currentMonth >= 7 && currentMonth <= 9) && form.year == currentYear) {
    return [1, 2, 3]; // Q3
  } else {
    return [1, 2, 3, 4]; // Q4 and previous years
  }
});

/*
function onMdaChange() {
  const selected = mdas.value.find(item => item.id === mda.value)
  form.mdaName = selected ? selected.name : ''
}

const mdaFieldEditable = ref(false)
const amountApprovedFieldEditable = ref(false)

function toggleEditField(field) {
  if (field === 'mda') {
    fetchMDAsByGroupTypeId(form.groupTypeId)
    mdaFieldEditable.value = !mdaFieldEditable.value
  } else if (field === 'amountApproved') {
    amountApprovedFieldEditable.value = !amountApprovedFieldEditable.value
  }
}

const fetchMDAsByGroupTypeId = async (grpTypeId) => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/mda/group/${grpTypeId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    mdas.value = response.data.map(mda => ({
      id: mda.id,
      name: mda.name,
    }))

  } catch (error) {
    console.error('Failed to fetch roles:', error)
  }
}

watch(
  () => [form.mda, form.amount_approved],
  ([newMdaId, newAmountApproved]) => {
    if (newMdaId === appraisal.oldMdaId && Number(newAmountApproved) === Number(appraisal.oldAmountApproved)) {
      isEdited.value = false
    } else {
      isEdited.value = newMdaId !== appraisal.oldMdaId || Number(newAmountApproved) !== Number(appraisal.oldAmountApproved)
    }
  }
)
*/

// const mda_datas = ref('')

// const fetchSectors = async () => {
//   const token = Cookies.get('auth_token');
//   try {
//     const response = await axios.get(`${root_api_url}/eli/sector`, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         'Content-Type': 'application/json',
//       },
//     });

//     sectors.value = response.data.map(sector => ({
//       id: sector.id,
//       code: sector.sectorCode,
//       name: sector.description,
//     }))

//   } catch (error) {
//     console.error('Failed to fetch sectors:', error)
//   }
// }

// Composes the display rows for the current UI page from the cached batch,
// then applies the same client-side date filter scoped to just this page's
// slice.


// Drops the cached batch and re-fetches page 1 — used whenever something
// that changes what the backend returns (mdaId, status, search field)
// changes, since the old cache no longer applies.


watch(pageLength, () => {
  currentPage.value = 1
})

watch(filters, () => {
  currentPage.value = 1
}, { deep: true })

watch(() => filters.value.date, () => {
  currentPage.value = 1
})

const filteredItems = computed(() => {
  let filtered = appraisal_log.value

  // Apply date filter
  if (filters.value.date) {
    const now = new Date()
    filtered = filtered.filter(w => {
      const appraisalInitiatedDate = new Date(w.appraisalInitiatedDate)
      switch (filters.value.date) {
        case 'this_month':
          return appraisalInitiatedDate.getMonth() === now.getMonth() &&
            appraisalInitiatedDate.getFullYear() === now.getFullYear()
        case 'last_month': {
          const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1)
          return appraisalInitiatedDate.getMonth() === lastMonth.getMonth() &&
            appraisalInitiatedDate.getFullYear() === lastMonth.getFullYear()
        }
        case 'this_year':
          return appraisalInitiatedDate.getFullYear() === now.getFullYear()
        default:
          return true
      }
    })
  }

  // Apply date sorting (MOST RECENT FIRST)
  filtered = [...filtered].sort((a, b) => {
    return new Date(b.appraisalInitiatedDate) - new Date(a.appraisalInitiatedDate)
  })

  return filtered
})

const paginatedItems = computed(() => {
  const start = (currentPage.value - 1) * pageLength.value
  return filteredItems.value.slice(start, start + pageLength.value)
})

const totalPages = computed(() => {
  return Math.ceil(filteredItems.value.length / pageLength.value)
})

const totalElements = computed(() => {
  return filteredItems.value.length
})

const displayedPages = computed(() => {
  const pages = []
  const maxDisplayed = 5
  let startPage = Math.max(1, currentPage.value - Math.floor(maxDisplayed / 2))
  let endPage = Math.min(totalPages.value, startPage + maxDisplayed - 1)

  if (endPage - startPage < maxDisplayed - 1) {
    startPage = Math.max(1, endPage - maxDisplayed + 1)
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i)
  }

  return pages
})

const changePage = async (page) => {
  if (page < 1 || page > totalPages.value) return
  currentPage.value = page
}

function formatPercent(val) {
    return `${Math.round(Number(val) || 0)}%`
}

const viewApprovalAuthorityInfoModal = async () => {
  showApprovalAuthorityInfoModal.value = true;
  loadingApprovalAuthorityInfo.value = true;
  approvalAuthorityInfoError.value = '';
  approvalAuthorityInfo.value = null;

  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/app-auth/${form.approval_authority_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    approvalAuthorityInfo.value = response.data;
    console.log('Fetched approval authority info:', approvalAuthorityInfo.value);
  } catch (error) {
    console.error('Failed to fetch approval authority info:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Failed to fetch approval authority information. Please try again later.',
    });
  } finally {
    loadingApprovalAuthorityInfo.value = false;
    await fetchAppraisalSummary(); // Fetch appraisal summary after fetching approval authority info
  }
};

const closeApprovalAuthorityInfoModal = () => {
  showApprovalAuthorityInfoModal.value = false
}

const fetchAppraisalSummary = async () => {
  const token = Cookies.get('auth_token')
  
console.log('Fetching appraisal summary for MDA:', form.mda);

try {
    const response = await axios.get(`${root_api_url}/appraisal/appraisal/approval-authority-appraisals/${form.approval_authority_id}/${mda.value}/${form.year}/${form.quarter}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    appraisal_log.value = response.data
    console.log('Fetched appraisal summary batch:', appraisal_log)
    
  } catch (error) {
    console.error('Failed to fetch appraisal summary batch:', error)
    if (error.response && error.response.status === 404) {
      tableNotice.value = error.response.data?.errorMessage || 'No appraisals found.'
    } else {
      errorMessage.value = 'Failed to fetch appraisals. Please try again.'
    }
    return false
  }
}

const showTooltip = async (event, appraisal) => {
  hoveredItem.value = appraisal
  tooltipVisible.value = true

  const rect = event.currentTarget.getBoundingClientRect()

  tooltipX.value = rect.left + window.scrollX
  tooltipY.value = rect.bottom + window.scrollY + 8 // small offset

  await fetchAppraisal(appraisal.id)
}

const hideTooltip = () => {
  tooltipVisible.value = false
}

const fetchAppraisal = async (id) => {
  const token = Cookies.get('auth_token')
  isLoadingDetails.value = true
  try {
    const { data } = await axios.get(`${root_api_url}/appraisal/appraisal/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    if (data.natureOfExpenditure == 2) {
      data.natureOfExpenditure = 'Recurrent';
    } else if (data.natureOfExpenditure == 3) {
      data.natureOfExpenditure = 'Capital';
    } else if (data.natureOfExpenditure == 4) {
      data.natureOfExpenditure = 'Hybrid';
    }
    hoveredItem.value = {
      ...hoveredItem.value,
      ...data
    }
  } catch (err) {
    console.error('Error fetching Appraisal:', err)
  } finally {
    isLoadingDetails.value = false
  }
}

const fetchMDAs = async () => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/mda`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    mdas.value = response.data.map(mda => ({
      id: mda.id,
      name: mda.name,
    }))

  } catch (error) {
    console.error('Failed to fetch roles:', error)
  }
}


const fetchApprovalAuthority = async () => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/app-auth`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    // console.log('approval authority:', response.data)

    approval_authorities.value = response.data.map(approval_authority => ({
      id: approval_authority.id,
      description: approval_authority.description,
      unlimitedApprovalInd: approval_authority.unlimitedApprovalInd
    }))

  } catch (error) {
    console.error('Failed to fetch roles:', error)
  }
}

const handleSubmit = async () => {
  const token = Cookies.get('auth_token');

  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`


  // if (totalRequired.value > parseInt(form.exp_app_balance, 10)) {
  //   Swal.fire({
  //     html: `${iconHtmlError}
  //     <h1 style="font-weight:600;">Error</h1>
  //     <p>Total amount required (${(totalRequired.value).toLocaleString()}) exceeds approval authority's balance (${(form.exp_app_balance).toLocaleString()})</p>`,
  //     showConfirmButton: true,
  //     showCloseButton: true,
  //     icon: undefined,
  //   });

  //   loading.value = false;

  //   return;
  // }

  const appraisalData = {
    originatingMda: form.mdaName,
    approvalAuthority: form.approval_authority_name,
    natureOfExpenditure: form.nature_expenditure,
    amountApproved: form.amount_approved,
    purposeOfRequest: form.purpose_request,
    isRequestInBudgetInd: 0,
    approvedBudgetAmount: form.app_budget_line,
    amtReleasedToDate: form.app_released_line,
    balance: form.balance_line,
    performance: parseInt(form.performance_line, 10),
    appraisalEconomicItems: economicItems.value.map(item => ({
      // mdaLineItemBudgetId: item.approvedBudget,
      ecoCode: item.ecoCode,
      title: item.title,
      mdaLineItemBudgetId: item.mdaLineItemBudgetId,
      amountReleased: item.releasedToDate,
      amountRequired: item.amountRequired,
      amountBudgeted: item.approvedBudget,
      balance: item.balance,
      year: form.year,
      quarter: form.quarter,

    })),
    quarter: form.quarter,
    budgetYear: form.year,
    appraisalInitiatedDate: form.exp_date,
    noOfAppLimitPerQtr: parseInt(form.exp_limit_number, 10),
    noOfAuthIssuedInQtr: parseInt(form.exp_app_quarter, 10),
    noOfAuthLeftInQtr: parseInt(form.exp_limit_balance, 10),
    qtrAuthLimitAmt: parseInt(form.exp_auth_amount, 10),
    approvedRecurrentAmount: parseInt(form.exp_rec_amount, 10),
    approvedCapitalAmount: parseInt(form.exp_cap_amount, 10),
    approvalBalance: parseInt(form.exp_app_balance, 10),
    evalRemarks: form.exp_remark,
    orgCode: form.orgCode,
    approvalAuthorityId: form.approval_authority_id,
    mdaId: mda.value,
    evalApprovedRecurrentAmount: parseInt(form.exp_rec_amount, 10),
    evalApprovedCapitalAmount: parseInt(form.exp_cap_amount, 10),
    evalApprovalBalance: parseInt(form.exp_app_balance, 10),
    memoId: memo_id,
    memoFileNumber: memoFileNumber.value,
    groupTypeId: form.groupTypeId,
    pvMemoId: form.pvMemoId,
    payVoucherId: form.payVoucherId,
    hasAssociatedPaymentVoucher: hasAssociatedPaymentVoucher.value,
  }

  loading.value = true;

  try {
    await axios.post(`${root_api_url}/appraisal/appraisal`, appraisalData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    Swal.fire({
      html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Appraisal Initiated Successfully</p> `,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    }).then(() => {
      // location.reload()
      // router.push({ name: 'GenerateAppraisal' })
      resetAll()
    });

  } catch (error) {
    if (error.response) {
      Swal.fire({
        html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>${error?.response?.data?.errorMessage || error?.response?.data?.error || 'Unexpected error occurred while initiating appraisal. Kindly contact administrator'}</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    } else {
      Swal.fire({
        html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>Unexpected error occurred while initiating appraisal. Kindly contact administrator</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    }
  } finally {
    loading.value = false; // Stop loading
  }
}

// const sendForApproval = async () => {
//   isPendingApproval.value = false
//   const token = Cookies.get('auth_token');

//   const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
//   const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

//   const appraisalData = {
//     originatingMda: form.mdaName,
//     approvalAuthority: form.approval_authority_name,
//     natureOfExpenditure: form.nature_expenditure,
//     amountApproved: form.amount_approved,
//     purposeOfRequest: form.purpose_request,
//     isRequestInBudgetInd: 0,
//     approvedBudgetAmount: form.app_budget_line,
//     amtReleasedToDate: form.app_released_line,
//     balance: form.balance_line,
//     performance: parseInt(form.performance_line, 10),
//     appraisalEconomicItems: economicItems.value.map(item => ({
//       // mdaLineItemBudgetId: item.approvedBudget,
//       ecoCode: item.ecoCode,
//       title: item.title,
//       mdaLineItemBudgetId: item.mdaLineItemBudgetId,
//       amountReleased: item.releasedToDate,
//       amountRequired: item.amountRequired,
//       amountBudgeted: item.approvedBudget,
//       balance: item.balance,
//       year: form.year,
//       quarter: form.quarter,

//     })),
//     quarter: form.quarter,
//     budgetYear: form.year,
//     appraisalInitiatedDate: form.exp_date,
//     noOfAppLimitPerQtr: parseInt(form.exp_limit_number, 10),
//     noOfAuthIssuedInQtr: parseInt(form.exp_app_quarter, 10),
//     noOfAuthLeftInQtr: parseInt(form.exp_limit_balance, 10),
//     qtrAuthLimitAmt: parseInt(form.exp_auth_amount, 10),
//     approvedRecurrentAmount: parseInt(form.exp_rec_amount, 10),
//     approvedCapitalAmount: parseInt(form.exp_cap_amount, 10),
//     approvalBalance: parseInt(form.exp_app_balance, 10),
//     evalRemarks: form.exp_remark,
//     orgCode: form.orgCode,
//     approvalAuthorityId: form.approval_authority_id,
//     mdaId: mda.value,
//     evalApprovedRecurrentAmount: parseInt(form.exp_rec_amount, 10),
//     evalApprovedCapitalAmount: parseInt(form.exp_cap_amount, 10),
//     evalApprovalBalance: parseInt(form.exp_app_balance, 10),
//     memoFileNumber: memoFileNumber.value,
//     groupTypeId: form.groupTypeId,
//     pvMemoId: form.pvMemoId,
//     payVoucherId: form.payVoucherId,
//     hasAssociatedPaymentVoucher: hasAssociatedPaymentVoucher.value,
//   }

//   loading.value = true;

//   try {
//     const { data } = await axios.put(`${root_api_url}/appraisal/appraisal/approval/${memo_id}`, appraisalData, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         'Content-Type': 'application/json',
//       },
//     });

//     console.log('Appraisal updated successfully:', data);
//     await Swal.fire({
//       html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Appraisal Updated Successfully, Sent for Approval</p> `,
//       showConfirmButton: true,
//       showCloseButton: true,
//       icon: undefined,
//     })

//   } catch (error) {
//     console.error('Error updating appraisal:', appraisalData);
//     if (error.response) {
//       Swal.fire({
//         html: `${iconHtmlError}
//         <h1 style="font-weight:600;">Error</h1>
//         <p>${error.response.data.message ?? 'Unexpected error occurred while updating appraisal.'}</p>`,
//         showConfirmButton: true,
//         showCloseButton: true,
//         icon: undefined,
//       });
//     }
//   } finally {
//     loading.value = false; // Stop loading
//     isPendingApproval.value = true
//     mdaFieldEditable.value = false
//     amountApprovedFieldEditable.value = false
//     isEdited.value = false
//   }
// }

const remainingChars = (val) => 200 - (val || '').length

function syncApprovalAuthority() {
  const sel = approval_authorities.value.find(a => a.id === form.approval_authority)
  if (sel) {
    form.approval_authority_id = sel.id
    form.approval_authority_name = sel.description
    form.approval_authority_unlimited = sel.unlimitedApprovalInd === 1
  } else {
    form.approval_authority_id = ''
    form.approval_authority_name = ''
    form.approval_authority_unlimited = false
  }
}

//start all ecoli fecth new

const ecoOptions = ref([])
const filteredEcoOptions = computed(() =>
  ecoOptions.value.filter(item =>
    [item.ecoCode, item.title]
      .join(' ')
      .toLowerCase()
      .includes(searchTerm.value.toLowerCase())
  )
)

const economicItems = ref([])      // rows in your table
const searchTerm = ref('')      // for filtering the select
const newEcoId = ref(null)    // ID of the item selected in dropdown
const selectedEco = ref(null)    // full object for that ID

const fetchEcoOptions = async (mdaid, year, nature_expenditure) => {
  const token = Cookies.get('auth_token')
  try {
    const { data } = await axios.get(`${root_api_url}/appraisal/appraisal/budget/${mdaid}/${year}/${nature_expenditure}`, {
      headers: { Authorization: `Bearer ${token}` }
    })



    // console.log(data);

    ecoOptions.value = (data.ecoLineItemDtos || []).map(dto => ({
      id: dto.id,
      //ecoCode: dto.economicLineItemDto.economicCode,
      ecoCode: dto.economicCode,
      title: dto.title,
      approvedBudget: dto.amountBudgeted,
      releasedToDate: dto.amountReleased,
      balance: dto.balance,
      performance: dto.performance,
      mdaLineItemBudgetId: dto.id,
    }));

    // console.log(ecoOptions.value);

    form.orgCode = data.organizationCode;
    form.app_budget_line = data.amountBudgeted;
    form.app_released_line = data.amountReleased;
    form.balance_line = data.balance;
    form.performance_line = data.performance;
    form.budget_year_line = data.year;

  } catch (err) {
    console.error('Error loading ECO items:', err)
    throw err;
  }
}

function onSelectEco() {
  selectedEco.value = ecoOptions.value.find(e => e.id === newEcoId.value) || null
}

function addSelectedEco() {
  if (!selectedEco.value) return

  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

  // prevent duplicates
  const exists = economicItems.value.some(e => e.id === selectedEco.value.id)
  if (exists) {
    return Swal.fire({
      html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>This economic item is already added</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    });
  }

  economicItems.value.push({
    id: selectedEco.value.id,
    ecoCode: selectedEco.value.ecoCode,
    title: selectedEco.value.title,
    approvedBudget: selectedEco.value.approvedBudget,
    releasedToDate: selectedEco.value.releasedToDate,
    balance: selectedEco.value.balance,
    amountRequired: 0,
    mdaLineItemBudgetId: selectedEco.value.mdaLineItemBudgetId,
  })

  // reset dropdown
  newEcoId.value = null
  selectedEco.value = null
}

const removeItem = (index) => {
  economicItems.value.splice(index, 1)
}

const clearEcoOptions = () => {
  ecoOptions.value = []
  newEcoId.value = null
  selectedEco.value = null
  searchTerm.value = ''
  economicItems.value = []
}

//end

// Compute total available balance across all items
const totalBalance = computed(() =>
  economicItems.value.reduce((sum, item) => sum + item.balance, 0)
)

const totalRequired = computed(() =>
  economicItems.value.reduce((sum, item) => sum + (item.amountRequired || 0), 0)
)

const totalApprovedInQtr = computed(() =>
  Number(form.exp_rec_amount || 0) + Number(form.exp_cap_amount || 0)
)


// function onMdaChange() {
//   console.log('MDA changed to', mda.value)
//   const selected = mdas.value.find(item => item.id === mda.value)
//   form.mdaName = selected ? selected.name : ''

//   fetchApprovalAuthority(mda.value)

//   // fetchMdaDetails(mda.value)
//   // fetchEcoOptions(mda.value)
// }

// function onSectorChange() {
//   console.log('Sector changed to', sector.value)
//   // fetchMdaDetails(mda.value)
//   fetchMDAs(sector.value)
// }

const fetchExpAppLImit = async (appauth, mda_id, quarter, year) => {
  const token = Cookies.get('auth_token')
  try {
    const { data } = await axios.get(`${root_api_url}/appraisal/appraisal/approval-authority-evaluation/${appauth}/${mda_id}/${quarter}/${year}`, {
      headers: { Authorization: `Bearer ${token}` }
    })



    // console.log(data);
    const today = new Date();
    const isoDate = today.toISOString();
    // console.log(isoDate);


    // form.exp_year = data.year;
    form.exp_quarter = data.quarter;
    form.exp_date = isoDate;
    form.exp_app_auth = data.approvalAuthorityName;
    form.exp_limit_number = data.noOfAuthIssuedInQtr;
    form.exp_app_quarter = data.noOfAppLimitPerQtr;
    form.exp_limit_balance = data.noOfAuthLeftInQtr;
    form.exp_auth_amount = data.qtrAuthLimitAmt;
    form.exp_cap_amount = data.approvedCapitalAmt;
    form.exp_rec_amount = data.approvedRecurrentAmt;
    form.exp_app_balance = data.approvalBalance;

  } catch (err) {
    console.error('Error loading Expenditure items:', err)
    throw err;
  }
}

// function formatDate(dateString) {
//   if (!dateString) return '';
//   const date = new Date(dateString);
//   return !isNaN(date) ? date.toISOString().slice(0, 10) : '';
// }

const formatInitDate = (value) => {
  if (!value) return ''

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value

  const day = date.getDate()
  const month = date.toLocaleString('en-US', { month: 'long' })
  const year = date.getFullYear()

  const getOrdinal = (number) => {
    const remainder = number % 100
    if (remainder >= 11 && remainder <= 13) return `${number}th`
    switch (number % 10) {
      case 1:
        return `${number}st`
      case 2:
        return `${number}nd`
      case 3:
        return `${number}rd`
      default:
        return `${number}th`
    }
  }

  return `${getOrdinal(day)} ${month} ${year}`
}


function validateStep2Amounts() {
  // Items where amountRequired is missing, null, undefined, or <= 0
  return economicItems.value
    .map((it, idx) => ({ ...it, _idx: idx }))
    .filter(it => !it.amountRequired || Number(it.amountRequired) <= 0);
}

function validateStep2ItemBalances() {
  // Items where amountRequired exceeds that item's own balance
  return economicItems.value
    .map((it, idx) => ({ ...it, _idx: idx }))
    .filter(it => Number(it.amountRequired || 0) > Number(it.balance || 0));
}

const createOccupier = async (appauth, mda_id, userId) => {
  const token = Cookies.get('auth_token')
  try {
    await axios.get(`${root_api_url}/eli/app-auth/appraisal-client/occupier/${appauth}/${mda_id}/${userId}`, {
      headers: { Authorization: `Bearer ${token}` }
    })



    // console.log(data);
    // const today = new Date();
    // const isoDate = today.toISOString().split('T')[0];


    // form.exp_year = data.year;
    // form.exp_quarter = data.quarter;
    // form.exp_date = isoDate;
    // form.exp_app_auth = data.approvalAuthorityName;
    // form.exp_limit_number = data.noOfAuthIssuedInQtr;
    // form.exp_app_quarter = data.noOfAppLimitPerQtr;
    // form.exp_limit_balance = data.noOfAuthLeftInQtr;
    // form.exp_auth_amount = data.qtrAuthLimitAmt;
    // form.exp_cap_amount = data.approvedCapitalAmt;
    // form.exp_rec_amount = data.approvedRecurrentAmt;
    // form.exp_app_balance = data.approvalBalance;

  } catch (err) {
    console.error('Error creating occupier:', err)
    throw err;
  }
}


const handleNext = async () => {
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`
  if (step.value === 1) {

    // loading.value = true
    // Check if all required fields are filled
    const emptyFields = [];

    // if (!sector.value) emptyFields.push("Sector");
    if (!mda.value) emptyFields.push("MDA");
    if (!form.approval_authority) emptyFields.push("Approval Authority");
    if (!form.year) emptyFields.push("Year");
    if (!form.quarter) emptyFields.push("Quarter");
    if (!form.nature_expenditure) emptyFields.push("Nature of Expenditure");
    if (!form.amount_approved) emptyFields.push("Amount Approved");
    if (!form.purpose_request) emptyFields.push("Purpose of Request");

    if (emptyFields.length > 0) {
      Swal.fire({
        html: `${iconHtmlError}
          <h1 style="font-weight:600;">Error</h1>
          <p>The following field(s) are empty:</p>
          <ul style="text-align:left;">${emptyFields.map(f => `<li>${f}</li>`).join('')}</ul>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
      return;
    }

    // 2️⃣ Turn on loading spinner
    loading.value = true// Show loading icon/button

    try {
      await fetchEcoOptions(mda.value, form.year, form.nature_expenditure)

      await createOccupier(form.approval_authority, mda.value, userId.value)


      // if (
      //   !form.orgCode ||
      //   !form.app_budget_line ||
      //   !form.app_released_line ||
      //   !form.balance_line ||
      //   !form.performance_line ||
      //   !form.budget_year_line
      // ) {
      //   Swal.fire({
      //     html: `${iconHtmlError}
      //       <h1 style="font-weight:600;">Error</h1>
      //       <p>Budget for the MDA or Year could not be found</p>`,
      //     showConfirmButton: true,
      //     showCloseButton: true,
      //     icon: undefined,
      //   });
      //   loading.value = false;
      //   return;
      // }

      // const isEmpty = (value) => value === null || value === undefined;

      // const missingFields = [];

      // if (isEmpty(form.orgCode)) missingFields.push("Organization Code (orgCode)");
      // if (isEmpty(form.app_budget_line)) missingFields.push("Approved Budget Line (app_budget_line)");
      // if (isEmpty(form.app_released_line)) missingFields.push("Released Line (app_released_line)");
      // if (isEmpty(form.balance_line)) missingFields.push("Balance Line (balance_line)");
      // if (isEmpty(form.performance_line)) missingFields.push("Performance Line (performance_line)");
      // if (isEmpty(form.budget_year_line)) missingFields.push("Budget Year Line (budget_year_line)");

      // if (missingFields.length > 0) {
      //   Swal.fire({
      //     html: `${iconHtmlError}
      //       <h1 style="font-weight:600;">Error</h1>
      //       <p>The following field(s) are missing: <strong>${missingFields.join(", ")}</strong></p>`,
      //     showConfirmButton: true,
      //     showCloseButton: true,
      //     icon: undefined,
      //   });
      //   loading.value = false;
      //   return;
      // }
      // Proceed to next step
      // step.value++;
    } catch (error) {
      if (error.response) {
        Swal.fire({
          html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>${error?.response?.data?.errorMessage || error?.response?.data?.error || 'Unexpected error occurred, kindly contact administrator'}</p>`,
          showConfirmButton: true,
          showCloseButton: true,
          icon: undefined,
        });
      } else {
        Swal.fire({
          html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>Unexpected error occurred, kindly contact administrator</p>`,
          showConfirmButton: true,
          showCloseButton: true,
          icon: undefined,
        });
      }

      return;
    } finally {
      loading.value = false; // Stop loading
    }
  }
  if (step.value === 2) {

    if (!economicItems.value || economicItems.value.length === 0) {
      Swal.fire({
        html: `${iconHtmlError}
          <h1 style="font-weight:600;">Error</h1>
          <p>No Economic Line Item Selected</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });

      return;
    }

    if (form.nature_expenditure == 4) {
      const hasCapitalExpenditure = economicItems.value.some(item => item.ecoCode.toString().charAt(0) === '3');
      const hasRecurrentExpenditure = economicItems.value.some(item => item.ecoCode.toString().charAt(0) === '2');

      if (!hasCapitalExpenditure || !hasRecurrentExpenditure) {
        const missing = [];
        if (!hasCapitalExpenditure) missing.push('Capital Expenditure (3xxx)');
        if (!hasRecurrentExpenditure) missing.push('Recurrent Expenditure (2xxx)');

        Swal.fire({
          html: `${iconHtmlError}
            <h1 style="font-weight:600;">Error</h1>
            <p>You need at least one item for: ${missing.join(' and ')}</p>`,
          showConfirmButton: true,
          showCloseButton: true,
          icon: undefined,
        });

        return;
      }
    }

    if (totalRequired.value > form.amount_approved) {
      Swal.fire({
        html: `${iconHtmlError}
          <h1 style="font-weight:600;">Error</h1>
          <p>Total amount required (₦${formatCurrency(totalRequired.value)}) exceeds the Amount Approved (₦${formatCurrency(form.amount_approved)}) from Step 1</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
      return;
    }

    if (totalRequired.value > totalBalance.value) {
      Swal.fire({
        html: `${iconHtmlError}
          <h1 style="font-weight:600;">Error</h1>
          <p>Total required (${(totalRequired.value).toLocaleString()}) exceeds total available balance (${(totalBalance.value).toLocaleString()})</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });

      return;
    }

    const missingAmounts = validateStep2Amounts();
    if (missingAmounts.length > 0) {
      Swal.fire({
        html: `${iconHtmlError}
          <h1 style="font-weight:600;">Error</h1>
          <p>The following line item(s) do not have an Amount Required (must be > 0):</p>
          <ul style="text-align:left;">
            ${missingAmounts.map(it => `<li>${it.ecoCode} — ${it.title}</li>`).join('')}
          </ul>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });

      return;
    }

    const overBalanceItems = validateStep2ItemBalances();
    if (overBalanceItems.length > 0) {
      Swal.fire({
        html: `${iconHtmlError}
          <h1 style="font-weight:600;">Error</h1>
          <p>The following line item(s) have an Amount Required that exceeds their own available balance:</p>
          <ul style="text-align:left;">
            ${overBalanceItems.map(it => `<li>${it.ecoCode} — ${it.title}: required ₦${formatCurrency(it.amountRequired)} exceeds balance ₦${formatCurrency(it.balance)}</li>`).join('')}
          </ul>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });

      return;
    }


    loading.value = true

    try {
      await fetchExpAppLImit(form.approval_authority_id, mda.value, form.quarter, form.year)
    } catch (error) {
      // console.error('API error:', error);
      // Swal.fire({
      //   html: `${iconHtmlError}
      //     <h1 style="font-weight:600;">Error</h1>
      //     <p>Something went wrong while validating.</p>`,
      //   showConfirmButton: true,
      //   showCloseButton: true,
      //   icon: undefined,
      // });

      if (error.response) {
        Swal.fire({
          html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>${error?.response?.data?.errorMessage || error?.response?.data?.error || 'Unexpected error occurred, kindly contact administrator'}</p>`,
          showConfirmButton: true,
          showCloseButton: true,
          icon: undefined,
        });
      } else {
        Swal.fire({
          html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>Unexpected error occurred, kindly contact administrator</p>`,
          showConfirmButton: true,
          showCloseButton: true,
          icon: undefined,
        });
      }
      return;
    } finally {
      loading.value = false; // Stop loading
    }
    if (!form.approval_authority_unlimited && totalRequired.value > parseInt(form.exp_app_balance, 10)) {
      Swal.fire({
        html: `${iconHtmlError}
          <h1 style="font-weight:600;">Error</h1>
          <p>Total amount required (${(totalRequired.value).toLocaleString()}) exceeds approval authority's balance (${(form.exp_app_balance).toLocaleString()})</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });

      loading.value = false;

      return;
    }
  }

  if (step.value < totalSteps) step.value++
}

const handleBack = () => {
  if (step.value > 1) step.value--
}

// function onAmountRequiredChange(idx) {
//   const item = economicItems.value[idx];
//   const available = item.balance;

//   // if within balance: just subtract
//   item.balance = available - item.amountRequired;
//   return;

//   // console.log(item.balance);

//   // else: overflow
//   // const overflow = item.amountRequired - available;

//   // // clamp this item
//   // item.amountRequired = available;
//   // item.balance = 0;

//   // find the next ECO option that's not yet used
//   // const nextOpt = ecoOptions.value.find(
//   //   o => !economicItems.value.some(e => e.id === o.id)
//   // );

//   // if (!nextOpt) {
//   //   Swal.fire({
//   //     icon: 'error',
//   //     title: 'No more line items',
//   //     text: 'You have exceeded all available ECO items.'
//   //   });
//   //   return;
//   // }

//   // ② Insert a new ECO row immediately after the current one
//   // economicItems.value.splice(idx + 1, 0, {
//   //   id: nextOpt.id,
//   //   ecoCode: nextOpt.ecoCode,
//   //   title: nextOpt.title,
//   //   approvedBudget: nextOpt.approvedBudget,
//   //   releasedToDate: nextOpt.releasedToDate,
//   //   balance: nextOpt.balance - overflow,
//   //   amountRequired: overflow
//   // });
// }

watch(
  [() => mda.value, () => form.year],
  ([newMda, newYear], [oldMda, oldYear]) => {
    // only act if something actually changed
    if (newMda !== oldMda || newYear !== oldYear) {
      economicItems.value = []
      ecoOptions.value = []
      newEcoId.value = null
      searchTerm.value = ''
    }
  }
)


/**
 * Format any number with commas
 */
function formatNumber(val) {
  return Number(val || 0).toLocaleString();
}

/**
 * Block keys other than digits, comma, or navigation
 */
// function onlyDigitsAndComma(e) {
//   const k = e.key;
//   if (
//     (k >= '0' && k <= '9') ||
//     k === ',' || k === '.' ||
//     ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(k)
//   ) return;
//   e.preventDefault();
// }

// /**
//  * Handle the “Amount Approved” input:
//  * - strip non‑digits
//  * - update the numeric model
//  * - re‑format the visible field
//  */
// function onAmountApprovedInput(e) {
//   const digits = e.target.value.replace(/[^\d]/g, '');
//   form.amount_approved = digits === '' ? 0 : Number(digits);
//   e.target.value = formatNumber(form.amount_approved);
// }

// function onItemAmountInput(e, item) {
//   const digits = e.target.value.replace(/[^\d]/g, '')
//   item.amountRequired = digits === '' ? 0 : Number(digits)
//   e.target.value = formatNumber(item.amountRequired)
// }

/**
 * Format number as currency with 2 decimals and thousand separators.
 * Accepts numbers or numeric strings. Returns empty string for falsy values.
 */
function formatCurrency(val) {
  if (val === '' || val === null || val === undefined) return '';
  const num = Number(val);
  if (isNaN(num)) return '';
  return '₦' + num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/**
 * Keep a simple helper for integer display where you need no decimals.
 * (you can keep this if other parts use it)
 */
// function formatNumber(val) {
//   return Number(val || 0).toLocaleString();
// }

/**
 * Allow only digit keys and navigation/editing keys.
 */
function onlyDigitsAndComma(e) {
  const k = e.key;
  const allowed = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab', 'Home', 'End'];
  if ((k >= '0' && k <= '9') || allowed.includes(k)) return;
  e.preventDefault();
}

/**
 * Amount Approved input:
 * - strip non-digits,
 * - treat last two digits as cents,
 * - store numeric value in form.amount_approved,
 * - re-render formatted display with commas and two decimals.
 */
function onAmountApprovedInput(e) {
  // get only digits typed
  const raw = (e.target.value || '').replace(/\D/g, '');

  if (raw === '') {
    form.amount_approved = 0;
    e.target.value = '';
    return;
  }

  // last two digits are cents
  const num = parseInt(raw, 10) / 100;
  // keep numeric model with 2 decimals
  form.amount_approved = Number(num.toFixed(2));
  // show formatted string
  e.target.value = formatCurrency(form.amount_approved);
}

/**
 * Amount Required input for table items (works same way as above).
 * item is the economicItems row object.
 */
function onItemAmountInput(e, item) {
  const raw = (e.target.value || '').replace(/\D/g, '');

  if (raw === '') {
    item.amountRequired = 0;
    e.target.value = '';
    return;
  }

  const num = parseInt(raw, 10) / 100;
  item.amountRequired = Number(num.toFixed(2));
  e.target.value = formatCurrency(item.amountRequired);
}


const getMemoDetails = async (memo_id) => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/appraisal/memo/${memo_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    // console.log('check memo in method', response)

    // memo_details.value = response.data.map(memo_detail => ({
    //   id: memo_detail.id,
    //   mda: memo_detail.mdaId,
    //   amountApproved: memo_detail.amountApproved,
    //   purposeOfRequest: memo_detail.purposeOfRequest,
    // }))

    memo_details.value = [{
      id: response.data.id,
      mda: response.data.mdaId,
      amountApproved: response.data.amountApproved,
      // purposeOfRequest: response.data.purposeOfRequest,
      fileNumber: response.data.fileNumber,
      groupTypeId: response.data.groupTypeId,
      pvMemoId: response.data.pvMemoId,
      payVoucherId: response.data.payVoucherId,
    }]


    memoFileNumber.value = response.data.fileNumber || ''
    form.pvMemoId = response.data.pvMemoId ?? ''
    form.payVoucherId = response.data.payVoucherId ?? ''

    // console.log('memo check', memo_details)

  } catch (error) {
    console.error('Failed to fetch memo details:', error)
  }
}

const getMdaDetails = async (mda_id) => {
  const token = Cookies.get('auth_token');
  try {
    const response = await axios.get(`${root_api_url}/eli/mda/${mda_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    // console.log('mda from method', response)

    mda_details.value = [{
      id: response.data.id,
      subSectorId: response.data.subSectorId,
      name: response.data.name,
      orgCode: response.data.orgCode,
    }]

    // mda_details.value = response.data.map(mda_detail => ({
    //   id: mda_detail.id,
    //   subSectorId: mda_detail.subSectorId,
    // }))

  } catch (error) {
    console.error('Failed to fetch mda details:', error)
  }
}

// const getSubSectorDetails = async (subsector_id) => {
//   const token = Cookies.get('auth_token');
//   try {
//     const response = await axios.get(`${root_api_url}/eli/sub-sector/${subsector_id}`, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         'Content-Type': 'application/json',
//       },
//     });

//     subsector_details.value = [{
//       id: response.data.id,
//       sectorId: response.data.sectorId,
//     }]

//     // console.log('sub sectore', subsector_details)

//     // subsector_details.value = response.data.map(subsector_detail => ({
//     //   id: subsector_detail.id,
//     //   sectorId: subsector_detail.sectorId,
//     // }))

//   } catch (error) {
//     console.error('Failed to fetch subsector details:', error)
//   }
// }

// const getSectorDetails = async (sector_id) => {
//   const token = Cookies.get('auth_token');
//   try {
//     const response = await axios.get(`${root_api_url}/eli/sector/${sector_id}`, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         'Content-Type': 'application/json',
//       },
//     });

//     subsector_details.value = [{
//       id: response.data.id,
//       sectorCode: response.data.sectorCode,
//       description: response.data.description
//     }]

//     // sector_details.value = response.data.map(sector_detail => ({
//     //   id: sector_detail.id,
//     //   sectorId: sector_detail.sectorCode,
//     // }))

//   } catch (error) {
//     console.error('Failed to fetch sector details:', error)
//   }
// }

const loadFullMemoDetails = async (memo_id) => {
  try {
    // console.log('loading memo', memo_id)
    await getMemoDetails(memo_id)

    if (!memo_details.value || memo_details.value.length === 0) return

    const memo = memo_details.value[0]

    // set mda and basic fields from memo
    mda.value = memo.mda || ''
    form.amount_approved = memo.amountApproved ? Number(memo.amountApproved) : 0
    // form.purpose_request = memo.purposeOfRequest || ''

    form.groupTypeId = memo.groupTypeId ?? null
    form.pvMemoId = memo.pvMemoId ?? ''
    form.payVoucherId = memo.payVoucherId ?? ''

    // If we have an mda id, fetch more details
    if (mda.value) {
      await getMdaDetails(mda.value)

      if (mda_details.value && mda_details.value.length > 0) {


        await fetchMDAs()

        // set form.mdaName from mdas list (if available)
        const sel = mdas.value.find(item => item.id === mda.value)
        form.mdaName = sel ? sel.name : form.mdaName

        // load approval authorities for the MDA
        await fetchApprovalAuthority()

        // optionally auto-select first approval authority if you want:
        if (approval_authorities.value && approval_authorities.value.length > 0) {
          // form.approval_authority = approval_authorities.value[0].id
          syncApprovalAuthority()
        }

        // const subsector_id = mda_details.value[0].subSectorId

        // fetch subsector -> get sector id
        // if (subsector_id) {
        //   await getSubSectorDetails(subsector_id)

        //   if (subsector_details.value && subsector_details.value.length > 0) {
        //     const sector_id = subsector_details.value[0].sectorId

        //     if (sector_id) {
        //       // make sure sectors list has been loaded (see onMounted)
        //       // set sector v-model so the select shows it
        //       sector.value = sector_id

        //       // fetch all MDAs for this sector so the MDA select has options
        //       await fetchMDAs(sector_id)

        //       // set form.mdaName from mdas list (if available)
        //       const sel = mdas.value.find(item => item.id === mda.value)
        //       form.mdaName = sel ? sel.name : form.mdaName

        //       // load approval authorities for the MDA
        //       await fetchApprovalAuthority()

        //       // optionally auto-select first approval authority if you want:
        //       if (approval_authorities.value && approval_authorities.value.length > 0) {
        //         form.approval_authority = approval_authorities.value[0].id
        //         syncApprovalAuthority()
        //       }
        //     }
        //   }
        // }
      }
    }

  } catch (error) {
    console.error('Failed to load full memo details:', error)
  }
}


// const loadFullMemoDetails = async (memo_id) => {
//   try {

//     console.log('test memo id check', memo_id)

//     await getMemoDetails(memo_id)

//     if (memo_details.value.length > 0) {
//       console.log('memo details', memo_details)
//       const mda_id = memo_details.value[0].mda

//       await getMdaDetails(mda_id)



//       if (mda_details.value.length > 0) {
//         console.log('mda details', mda_details.value[0].id)

//         await fetchApprovalAuthority(mda_details.value[0].id)
//         const subsector_id = mda_details.value[0].subSectorId

//         await getSubSectorDetails(subsector_id)


//           if (subsector_details.value.length > 0) {
//             console.log('sub sector details', subsector_details)
//             const sector_id = subsector_details.value[0].sectorId

//             await getSectorDetails(sector_id)

//             if (sector_details.value.length > 0) {

//               console.log('sector details', sector_details)

//             }
//           }
//       }
//     }
//   } catch (error) {
//     console.error('Failed to load full memo details:', error)
//   }
// }


// const getMemoDetails = async (memo_id) => {
//   const token = Cookies.get('auth_token');
//   try {
//     const { data } = await axios.get(`${root_api_url}/appraisal/memo/${memo_id}`, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         'Content-Type': 'application/json',
//       },
//     });

//     // keep your existing mapped structure
//     memo_details.value = (data || []).map(memo_detail => ({
//       id: memo_detail.id,
//       mda: memo_detail.mdaId,
//       amountApproved: memo_detail.amountApproved,
//       purposeOfRequest: memo_detail.purposeOfRequest,
//     }));

//     // if there's at least one memo record, prefill the form fields
//     if (Array.isArray(data) && data.length > 0) {
//       const first = data[0];
//       // numeric amount (store as number)
//       form.amount_approved = first.amountApproved ? Number(first.amountApproved) : 0;
//       form.purpose_request = first.purposeOfRequest || '';
//       // set mda id so we can fetch subsector -> sector etc
//       mda.value = first.mdaId || '';
//     }

//   } catch (error) {
//     console.error('Failed to fetch memo details:', error)
//   }
// }


// const loadFullMemoDetails = async (memo_id) => {
//   try {

//     await getMemoDetails(memo_id)


//     if (!mda.value) return


//     await getMdaDetails(mda.value)

//     if (mda_details.value.length > 0) {
//       const subsector_id = mda_details.value[0].subSectorId


//       await getSubSectorDetails(subsector_id)

//       if (subsector_details.value.length > 0) {
//         const sector_id = subsector_details.value[0].sectorId


//         sector.value = sector_id


//         await fetchMDAs(sector_id)


//         const sel = mdas.value.find(item => item.id === mda.value)
//         form.mdaName = sel ? sel.name : form.mdaName


//         await fetchApprovalAuthority(mda.value)
//       }
//     }
//   } catch (error) {
//     console.error('Failed to load full memo details:', error)
//   }
// }


// onMounted(() => {
//   // fetchApprovalAuthority()
//   // fetchMDAs()
//   fetchSectors(),
//   loadFullMemoDetails(memo_id),
//   document.title = "Initiate Appraisal"
// })

onMounted(async () => {
  try {
    // await fetchSectors()
    await loadFullMemoDetails(memo_id)
  } catch (err) {
    console.error('onMounted error', err)
  }
  document.title = "Initiate Appraisal"
})

watch(
  () => userStore.profile?.id,
  (newId) => {
    if (newId) userId.value = newId
  },
  { immediate: true }
)




</script>

<style scoped>
.marquee-wrapper {
  width: 100%;
  overflow: hidden;
  background-color: #f2ffe6;
  padding: 0.5rem 0;
}

.marquee-content {
  display: inline-flex;
  white-space: nowrap;
  animation: marquee 20s linear infinite;
}

.marquee-content p {
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding: 0 2rem;
  font-size: 1rem;
  font-weight: 500;
  color: #856404;
}

.marquee-content:hover {
  animation-play-state: paused;
}

@keyframes marquee {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
}

.view-only-input {
  border: none !important;
  background-color: transparent;
  padding-left: 0;
  cursor: default;
  pointer-events: none;
  color: var(--color);
  font-size: 1rem;
  padding-right: 0;
  margin-right: 1rem;
}

.budget-item-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  /* forces every .col to match the tallest */
}

.budget-item-wrapper .view-only-input,
.budget-item-wrapper input.view-only-input {
  flex: 1;
  /* inputs (and your Approval‐Authority <div>) all grow equally */
  /* for your Approval Authority div: */
  white-space: pre-wrap;
}

.dashboard-layout .budget-item-wrapper {
  margin-top: 20px;
  padding: 0 40px;
}

.dashboard-layout .content-wrapper {
  border: 1px solid var(--border);
  background-color: var(--card);
  box-shadow: var(--shadow);
  padding: 1rem;
}

.dashboard-layout .section-border {
  /* padding: 1rem; */
  border-top: 3px solid #667eea !important;
}

.dashboard-layout .step-2 {
  padding: 0 20px;
}

.dashboard-layout .budget-item-wrapper.step-2 .col {
  border-right: 1px solid var(--border) !important;
  /* box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05); */
}

.dashboard-layout .budget-item-wrapper.step-2 .col.no-border {
  border-right: none !important;
}

.dashboard-layout .budget-item-wrapper.step-3 .fixed-label {
  min-height: 80px;
  justify-content: flex-start;
  width: auto;
  box-sizing: border-box;
  text-align: left;
  /* all: unset; */
  display: flex;
  margin-bottom: 0;
  flex-shrink: 0;
  margin-left: 1rem;
}

.dashboard-layout .budget-item-wrapper.step-3 .col {
  padding: 0;
}

.dashboard-layout .budget-item-wrapper.step-3 .content-wrapper {
  border: 1px solid var(--border);
  background-color: var(--card);
  box-shadow: var(--shadow);
  /* padding: 1rem; */
}

.dashboard-layout .budget-item-wrapper.step-3 .content {
  border-bottom: 2px solid var(--border);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  gap: 1rem;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.dashboard-layout .budget-item-wrapper.step-3 label {
  font-size: 16px;
  padding: .375rem 0 !important;
  margin-bottom: 0px !important;
  padding-bottom: 0.5rem;
  font-weight: 600;
}

.dashboard-layout .budget-item-wrapper .col-md-3 {
  border: 1px solid #212529;
}

.dashboard-layout .budget-item-wrapper .col-md-3.no-border {
  border: none;
}

.dashboard-layout .budget-item-wrapper .col-md-3.no-border label {
  padding: .375rem .75rem;
  margin-bottom: 0px !important;
}

.dashboard-layout .budget-item-wrapper .col-md-2.no-border {
  border: none;
}

.dashboard-layout .budget-item-wrapper .col-md-2.no-border label {
  padding: .375rem .75rem;
  margin-bottom: 0px !important;
}

.dashboard-layout .fixed-label {
  display: flex;
  align-items: center;
  /* vertical center */
  justify-content: center;
  /* horizontal center */
  min-height: 4rem;
  width: 100%;
  padding: 0 0.25rem;
  box-sizing: border-box;
  text-align: center;
}

.editable {
  border: 1px dashed #aaa !important;
  background-color:var(--table-bg-head);
}

.edit-icon {
  font-size: 16px;
  color: #aaa;
  cursor: pointer;
}

.edit-icon-filled {
  font-variation-settings:
    'FILL' 1,
    'wght' 400,
    'GRAD' 0,
    'opsz' 24
}

.material-symbols-outlined {
  font-size: 1.25rem;
}

.form-row-input {
  flex: 1;
}

/* Approval Authority Tooltip */
.app-auth-tooltip-wrapper {
  position: relative;
}

.app-auth-tooltip-text {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  background-color: var(--bg);
  color: var(--card);
  font-size: 0.8rem;
  font-weight: 500;
  white-space: nowrap;
  padding: 0.4rem 0.65rem;
  border-radius: 4px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.15s ease, transform 0.15s ease;
  z-index: 10;
}

.app-auth-tooltip-text::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: var(--border) transparent transparent transparent;
}

.app-auth-tooltip-wrapper:hover .app-auth-tooltip-text,
.app-auth-tooltip-wrapper:focus-within .app-auth-tooltip-text {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

.app-auth-info-overlay {
  position: fixed;
  inset: 0;
  z-index: 1060;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.app-auth-info-modal {
  width: min(1000px, 100%);
  max-height: 90vh;
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--card);
  display: flex;
  flex-direction: column;
}

.app-auth-info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid var(--border);
}

.app-auth-info-body {
  padding: 1rem;
  overflow: auto;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.6rem;
}

.info-item {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 0.6rem 0.75rem;
}

.info-item small {
  color: #6b7280;
  font-size: 0.75rem;
}

.info-item p {
  color: var(--color);
  font-weight: 600;
}

@keyframes approvalAuthoritySkeletonShimmer {
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
}

.app-auth-skeleton-bar {
  height: 14px;
  border-radius: 4px;
  background: linear-gradient(90deg, #eceff1 25%, #f5f6f7 37%, #eceff1 63%);
  background-size: 400% 100%;
  animation: approvalAuthoritySkeletonShimmer 1.4s ease infinite;
}

@media (max-width: 576px) {
  .info-grid {
    grid-template-columns: 1fr;
  }
}

/* Component-specific styles only for appraisal logs */
.appraisal-date {
  min-width: 150px;
}

.primary-col {
  font-weight: 500;
}

.row-even {
  background-color: #ffffff;
}

.row-odd {
  background-color:var(--table-bg-head);
}

.custom-tooltip {
  position: fixed;
  z-index: 9999;
  background: var(--card);
  color: var(--color);
  padding: 12px 14px;
  border-radius: 8px;
  font-size: 13px;
  max-width: 300px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  pointer-events: none;
  animation: fadeIn 0.15s ease-in-out;
}

.custom-tooltip p {
  margin: 0 0 6px;
}

.custom-tooltip p:last-child {
  margin-bottom: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(4px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

</style>
